import React from 'react';
import RansomwareMap from "../map/ransomwareMap";

const RansomwareModule = () => {

    return (
    <RansomwareMap/>
)
}
export default RansomwareModule;